<template>
  <Transition appear>
    <div v-if="isVisible" class="success-overlay">
      <div class="success-content">
        <h2 class="success-title">{{ title }}</h2>
        <p class="success-text">{{ text }}</p>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "SuccessOverlay",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.success-overlay {
  position: absolute;
  top: -10px;
  right: -10px;
  bottom: -10px;
  left: -10px;
  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  background: rgba(245, 255, 226, 0.78);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  backdrop-filter: blur(7.5px);
}

.success-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--cr-spacing-xs);

  padding: var(--cr-spacing-xs);

  text-align: left;
}

.success-title {
  @include font-family("heading");
  @include scale-fonts("heading-2");
}

.success-text {
  @include font-family("body");
  @include scale-fonts("body");
}

.v-enter-active,
.v-leave-active {
  transition: opacity 500ms ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
